import React, { useEffect } from 'react'
import { useNavigate } from "react-router-dom"
import { useDispatch } from 'react-redux';
import { clearCart } from '../redux/Slices/cartSlice';
import axiosConfig from "../Service/axiosConfig"

const Logout = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const token = localStorage.getItem("token")

    useEffect(() => {
        const logoutUser = async () => {
            try {
                await axiosConfig.post("/accounts/api/logout/", {},
                    {
                        headers: {
                            Authorization: `Token ${token}`,
                        }
                    });
            } catch (error) {
                console.log("Logout API error:", error);
            }
            localStorage.removeItem("token")
            localStorage.removeItem('userId');
            localStorage.removeItem('userid');
            localStorage.removeItem('number');
            localStorage.removeItem('address_id');
            localStorage.removeItem('traveltime');
            localStorage.removeItem('wishlists');
            localStorage.removeItem('total');
            localStorage.removeItem('orderId');
            localStorage.removeItem('verifiedZipcode');
            localStorage.removeItem('savedZipcode');
            dispatch(clearCart());
            return navigate("/")
        }
        logoutUser()
    }, [])
}

export default Logout;
